module.exports = __webpack_public_path__ + "media/transport_protocols/Communication-6a0fd883.svg";